class AdminToolSectionService {
  constructor(httpDim, config) {
    this.httpDim = httpDim;
    this.config = config;
  }

  triggerOrchestration(customerId, type, triggerDependencies = false, sourceSystemId = '', status = '') {
    const url = `${this.config.apiRoot}/adminTools/customers/${customerId}/orchestration`;
    return this.httpDim.post(url, {
      type,
      sourceSystemId,
      triggerDependencies,
      status
    }, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    });
  }

  triggerSubgroupOrchestration(customerId, action = null) {
    const data = action ? { action } : {};
    const url = `${this.config.apiRootV2}/adminTools/customers/${customerId}/subgroups/orchestration`;
    return this.httpDim.post(url, data);
  }

  getServices () {
    const url = `${ this.config.apiRoot }/adminTools/services`;
    return this.httpDim.get(url, {});
  }

  updateServices(services) {
    const url = `${ this.config.apiRoot }/adminTools/services`;
    return this.httpDim.patch(url, services, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    });
  }

  getMessages() {
    const url = `${ this.config.apiRoot }/adminTools/queues/dead/messages`;
    return this.httpDim.get(url, {});
  }

  replayMessages(messages) {
    const url = `${ this.config.apiRoot }/adminTools/queues/dead/messages`;
    return this.httpDim.post(url, messages, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    });
  }

  purgeMessages(messages) {
    const url = `${ this.config.apiRoot }/adminTools/queues/dead/messages`;
    return this.httpDim.put(url, messages,{
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    });
  }

  removeMapping(customerId, entity, entityId) {
    const query = entityId ? `?entityId=${entityId}` : '';
    const url = `${this.config.apiRoot}/adminTools/customers/${customerId}/mappings/${entity}${query}`;
    return this.httpDim.delete(url);
  }

  resetBatch(batchId, batchConfig) {
    const url = `${this.config.apiRoot}/batches/${batchId}/reset`;
    return this.httpDim.post(url, batchConfig || {});
  }

  mapCourseProducts(customerId) {
    const url = `${this.config.apiRoot}/adminTools/customers/${customerId}/mapCourseProducts`;
    return this.httpDim.post(url, {});
  }

  resetCustomer(customerId, hardReset) {
    const url = `${this.config.apiRoot}/adminTools/customers/${customerId}/reset?hardReset=${hardReset}`;
    return this.httpDim.post(url, {});
  }

  createPAReport(customerId, includeAssignedSchools) {
    const url = `${this.config.apiRoot}/adminTools/customers/${customerId}/productAssignmentReport?includeAssignedSchools=${includeAssignedSchools}`;
    return this.httpDim.post(url, {});
  }

  createOneRoster(customerId) {
    const url = `${this.config.apiRoot}/adminTools/customers/${customerId}/createOneRoster`;
    return this.httpDim.post(url, {});
  }

  getLastBatch(customerId) {
    const url = `${ this.config.apiRoot }/customers/${ customerId }/batches/last`;
    return this.httpDim.get(url, {});
  }

  getConflictingSourcedIds(customerId, offset, limit) {
    const url = `${this.config.apiRoot}/adminTools/customers/${customerId}/overwrite?offset=${offset}&limit=${limit}`;
    return this.httpDim.get(url, {});
  }

  getInProcessForwardableWorkflows(customerId) {
    const url = `${this.config.apiRoot}/adminTools/customers/${customerId}/workflows/forwardable?status=NEW,IN_PROGRESS`;
    return this.httpDim.get(url, {});
  }

  getCancelWorkflow(customerId) {
    const url = `${this.config.apiRoot}/adminTools/customers/${customerId}/workflows/forwardable?status=CANCEL`;
    return this.httpDim.get(url, {});
  }

  cancelWorkflow(customerId, workflowId, force) {
    const url = `${this.config.apiRoot}/adminTools/customers/${customerId}/workflows/${workflowId}?force=${force}`;
    return this.httpDim.delete(url, {});
  }

  retryCedUserLicenses(customerId) {
    const url = `${this.config.apiRoot}/adminTools/retryCedUserLicenses/customers/${customerId}/retryCedUserLicenses`;
    return this.httpDim.post(url, {});
  }

  overwrite(customerId, people, all = false) {
    const url = `${this.config.apiRoot}/adminTools/customers/${customerId}/overwrite`;
    return this.httpDim.post(url, {
      all,
      people
    });
  }

  deleteEntity(customerId, entity, sourceSystemId) {
    const url = `${this.config.apiRoot}/adminTools/${customerId}/${entity}/${sourceSystemId}`;
    return this.httpDim.delete(url);
  }

  forceSftpBatchTrigger(customerId) {
    const url = `${this.config.apiRootV2}/adminTools/transfer-family/force-file-ingestion/${customerId}`;
    return this.httpDim.post(url, {});
  }

  saveCredentials(provider, credentials) {
    const url = `${this.config.apiRootV2}/adminTools/credentials/${provider}`;
    return this.httpDim.post(url, credentials, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    });
  }

  getCredentialsStatus(provider) {
    const url = `${this.config.apiRootV2}/adminTools/credentials/${provider}/status`;
    return this.httpDim.get(url);
  }

  testExistingCredentials(provider) {
    const url = `${this.config.apiRootV2}/adminTools/credentials/${provider}/test`;
    return this.httpDim.post(url, {});
  }
}

AdminToolSectionService.$inject = ['httpDim', 'config'];

export default AdminToolSectionService;



// WEBPACK FOOTER //
// ./app/components/adminToolSection/adminToolSection.service.js